// This hook provides functionality for signing in with Google

import firebase from "../Firebase.js";
import { useHistory, useLocation } from "react-router-dom";
import { useAppStore } from "../stores/appStore.js";
import { isStagingBranch } from "../IsStagingBranch.js";
import * as Sentry from "@sentry/react";

const { detect } = require("detect-browser");

const useGoogleSignIn = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  const browser = detect();
  const location = useLocation();
  const history = useHistory();
  const mergeAccount = useAppStore((state) => state.mergeAccount);
  const setMergeAccount = useAppStore((state) => state.setMergeAccount);
  const googleSignIn = () => {
    // move the user to /app for the google redirect
    if (history && !location.pathname.startsWith("/app/") && !location.pathname.startsWith("/pages")) {
      history.push("/?fromAuth");
    }

    const currentUser = firebase.auth().currentUser;

    /**
     * SignInWithRedirect is the preferred signin method. However, it requires us to self-host
     * auth handlers to avoid third-party cookie issues. This is not feasible for staging URLs or
     * when in a local dev environment, so in those cases we use signInWithPopup instead.
     */
    if (process.env.NODE_ENV === "development" || process.env.REACT_APP_NODE_ENV === "development" || isStagingBranch()) {
      if (currentUser && currentUser.isAnonymous && mergeAccount) {
        // Link anonymous user with Google account
        currentUser
          .linkWithPopup(provider)
          .then((result) => {
            const credential = result.credential;
            const user = result.user;
            setMergeAccount(false);
          })
          .catch((error) => {
            if (error.code === "auth/credential-already-in-use") {
              // Handle the case where the Google account is already linked to another account
              return firebase.auth().signInWithCredential(error.credential);
            }

            Sentry.captureException(error, {
              tags: {
                func: "googleSignIn",
                userId: currentUser.uid,
              },
            });
          });
      } else {
        // Regular sign in if not anonymous
        firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            /** @type {firebase.auth.OAuthCredential} */
            const credential = result.credential;

            // This gives you a Google Access Token. You can use it to access the Google API.
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
          });
      }
    } else {
      if (currentUser && currentUser.isAnonymous && mergeAccount) {
        window.location.hash = "login";
        currentUser.linkWithRedirect(provider);
      } else {
        window.location.hash = "login";
        firebase.auth().signInWithRedirect(provider);
      }
    }
  };

  return googleSignIn;
};

export default useGoogleSignIn;
